/**
 * Close Cycle Analysis (FSD 2.2.8.10: "days to close by period with trend and
 * comparison to target"; 2.2.8.9 close bottleneck analysis).
 *
 * `closeReportsCycleAnalysis` — GET /reports/close-cycle-analysis — is the only
 * call. Every figure is the server's: days are counted on the tenant's clock,
 * averages and the trend arrive as one-decimal strings, and the bottleneck
 * ranking is the server's. Peer benchmarks are not produced: comparing one
 * tenant with others would read across the tenant boundary.
 */

import { closeReportsCycleAnalysis, type CloseCycleAnalysisDTO, type CloseCycleAnalysisQuery } from '@erpx/api'

import { api } from '@/api/client'

export type { CloseCycleAnalysisDTO }

export const CYCLE_PERMISSIONS = {
  read: 'close.run.read',
} as const

export const CYCLE_TRENDS = ['improving', 'worsening', 'flat', 'insufficient_data'] as const

export const CYCLE_KEYS = {
  report: (companyId: number | null, fiscalYear: number | null) =>
    ['close', 'cycle-analysis', companyId, fiscalYear] as const,
} as const

export function cycleAnalysis(companyId: number | null, fiscalYear: number | null): Promise<CloseCycleAnalysisDTO> {
  const query: CloseCycleAnalysisQuery = {
    ...(companyId === null ? {} : { companyId }),
    ...(fiscalYear === null ? {} : { fiscalYear }),
  }
  return closeReportsCycleAnalysis(api(), query)
}

export function trendTone(trend: string): 'success' | 'danger' | 'neutral' | 'info' {
  switch (trend) {
    case 'improving':
      return 'success'
    case 'worsening':
      return 'danger'
    case 'flat':
      return 'info'
    default:
      return 'neutral'
  }
}
